import Vue from 'vue'
import Vuex from 'vuex'
import chatbotList from './chatbotList/model'
import chatRoom from './chatRoom/model'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    chatbotList,
    chatRoom
  }
})



// WEBPACK FOOTER //
// ./src/store.js